/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "PlaidLink": {
                    "fields": {
                      "customerId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "verificationStatus": {
                        "type": "squareup.sfs.external.models.PlaidLink.PlaidVerificationStatus",
                        "id": 2,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "PlaidVerificationStatus": {
                        "values": {
                          "PLAID_VERIFICATION_STATUS_DO_NOT_USE": 0,
                          "INSTANTLY_VERIFIED": 1,
                          "PENDING_AUTOMATIC_VERIFICATION": 2,
                          "PENDING_MANUAL_VERIFICATION": 3,
                          "AUTOMATICALLY_VERIFIED": 4,
                          "MANUALLY_VERIFIED": 5,
                          "VERIFICATION_EXPIRED": 6,
                          "VERIFICATION_FAILED": 7
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.PlaidLink && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.PlaidLink?.nested?.PlaidVerificationStatus) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a successful Plaid Link that was initiated by the Savings customer, but has not yet been linked to
 * the Savings account.
 * --
 *
 * SOURCE PlaidLink @ squareup/sfs/external/models/plaid_link.proto at 11:1
 */
export const PlaidLink = $root.lookupType('squareup.sfs.external.models.PlaidLink');
fixType(PlaidLink, {
  customerId: {
    required: true
  },
  verificationStatus: {
    required: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(PlaidLink);
/**
 * SOURCE PlaidVerificationStatus @ squareup/sfs/external/models/plaid_link.proto at 12:3
 */
PlaidLink.PlaidVerificationStatus = $root.lookupEnum('squareup.sfs.external.models.PlaidLink.PlaidVerificationStatus').values;